import { LeadStatus } from '../../api/models';
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from '../utils';

const ACTION_LOAD_STATUS_REQUEST = 'ENTITIES/LOAD_STATUS_REQUEST';
const ACTION_LOAD_STATUS_SUCCESS = 'INTENT/LOAD_STATUS_SUCCESS';
const ACTION_LOAD_STATUS_ERROR = 'INTENT/LOAD_STATUS_ERROR';

export interface LeadStatusState {
  leadStatus: LeadStatus[];
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: LeadStatusState = {
  leadStatus: [],
  isLoaded: false,
  isLoading: false,
};

type LeadStatusRequestActionType = IAction<typeof ACTION_LOAD_STATUS_REQUEST>;

type LeadStatusSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_STATUS_SUCCESS,
  LeadStatus[]
>;

type LeadStatusErrorActionType = IAction<typeof ACTION_LOAD_STATUS_ERROR>;

type Actions =
  | LeadStatusRequestActionType
  | LeadStatusSuccessActionType
  | LeadStatusErrorActionType;

export const loadStatusRequestAction = (): LeadStatusRequestActionType => {
  return createAction(ACTION_LOAD_STATUS_REQUEST);
};

export const loadStatusSuccessAction = (
  data: LeadStatus[]
): LeadStatusSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_STATUS_SUCCESS, data);
};

export const loadStatusErrorAction = (): LeadStatusErrorActionType => {
  return createAction(ACTION_LOAD_STATUS_ERROR);
};

// reducer
export const leadStatusReducer = (
  state: LeadStatusState = initialState,
  action: Actions
): LeadStatusState => {
  switch (action.type) {
    case ACTION_LOAD_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_STATUS_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_STATUS_SUCCESS:
      return {
        ...state,
        leadStatus: action.payload,
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
